"use client";

import { Link } from "@/i18n/routing";
import { IconForwardArrowBlack } from "@repo/assets/images";
import { ACCOUNT_MENU } from "@repo/constants/account";
import { useActivePath } from "@repo/lib/hooks/common";
import { useTrackAccountMenuClick } from "@repo/lib/hooks/webengage";
import cx from "classnames";
import { useTranslations } from "next-intl";
import { useCallback } from "react";
const Items = ({
  item,
  activePath,
  onClick
}) => {
  const t = useTranslations("Common");
  const IconComponent = item.icon;
  //TODO: Replace the below hard coded logic for order route with dynamic values
  const isOrdersRoute = activePath.startsWith("/account/orders/") && item.url === "/account/orders";
  const isActive = isOrdersRoute || activePath === item.url;
  return <li className={cx("border-supportiveDarkGray hover:bg-icon-bg hover:text-supportiveBlack border-b", {
    "bg-icon-bg text-supportiveBlack": isActive,
    "text-supportiveGray4": !isActive
  })} data-sentry-component="Items" data-sentry-source-file="AccountMenu.jsx">
      <Link href={item?.url} onClick={() => onClick(!isActive ? item.name : "")} className="border-lightgray flex items-center whitespace-nowrap rounded border p-2 md:border-0 md:p-4" data-sentry-element="Link" data-sentry-source-file="AccountMenu.jsx">
        <IconComponent className={cx("me-2 fill-current", {
        "text-icon-color": isActive
      })} data-sentry-element="IconComponent" data-sentry-source-file="AccountMenu.jsx" />
        <span className="font-medium">{t(item?.label)}</span>
        <IconForwardArrowBlack className={cx("ms-auto hidden fill-current md:block rtl:rotate-180", {
        "text-icon-color": isActive
      })} data-sentry-element="IconForwardArrowBlack" data-sentry-source-file="AccountMenu.jsx" />
      </Link>
    </li>;
};
const AccountMenu = () => {
  const t = useTranslations("Common");
  const {
    trackAccountMenuClickEvent
  } = useTrackAccountMenuClick();
  const activePath = useActivePath();
  const handleMenuItemClick = useCallback(menuTitle => {
    trackAccountMenuClickEvent(menuTitle);
  }, [trackAccountMenuClickEvent]);
  return <div className="hidden md:block" data-sentry-component="AccountMenu" data-sentry-source-file="AccountMenu.jsx">
      <ul className="border-supportiveDarkGray mb-4 mt-2.5 border border-b-0">
        {ACCOUNT_MENU.DasboardLinks?.map(item => <Items item={item} key={item.id} activePath={activePath} onClick={handleMenuItemClick} />)}
      </ul>
      <h4 className="font-heading rtl:font-arabic text-xl font-medium">
        {t("Account_Settings")}
      </h4>
      <ul className="border-supportiveDarkGray my-4 border border-b-0">
        {ACCOUNT_MENU.AccountSettings?.map(item => <Items item={item} key={item.id} activePath={activePath} onClick={handleMenuItemClick} />)}
      </ul>
      <h4 className="font-heading rtl:font-arabic text-xl font-medium">
        {t("Products")}
      </h4>
      <ul className="border-supportiveDarkGray my-4 border border-b-0">
        {ACCOUNT_MENU.Products?.map(item => <Items item={item} key={item.id} activePath={activePath} onClick={handleMenuItemClick} />)}
      </ul>
    </div>;
};
export default AccountMenu;